import api from "@/api";
import adaptive from "adaptive.js";
adaptive.desinWidth = 750;
adaptive.maxWidth = 500;
adaptive.baseFont = 24;
adaptive.init();

// es6扩展
if (!Object.assign) {
  Object.defineProperty(Object, "assign", {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function(target, firstSource) {
      "use strict";
      if (target === undefined || target === null)
        throw new TypeError("Cannot convert first argument to object");
      var to = Object(target);
      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for (
          var nextIndex = 0, len = keysArray.length;
          nextIndex < len;
          nextIndex++
        ) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
          if (desc !== undefined && desc.enumerable)
            to[nextKey] = nextSource[nextKey];
        }
      }
      return to;
    }
  });
}

// import VConsole from "vconsole";
// var vConsole = new VConsole();

// 微信注册
api("GETWXAPI", {
  link: self.location.href
}).then(res => {
  wx.config({
    debug: false,
    appId: res.appId,
    timestamp: res.timestamp,
    nonceStr: res.nonceStr,
    signature: res.signature,
    jsApiList: [
      "updateTimelineShareData",
      "updateAppMessageShareData",
      "onMenuShareAppMessage",
      "onMenuShareQQ",
      "onMenuShareQZone",
      "onMenuShareTimeline"
    ]
  });
  wx.ready(function() {
    var shareData = {
      title: "生 无畏",
      desc: "我是第" + res.nums + "个为“艾”发声人！",
      link: "http://" + self.location.host + location.search,
      imgUrl:
        "http://hivcampaign.gileadchina.cn/data/upfiles/20191113175956.jpg",
      success: function() {
        console.log("设置成功");
      }
    };
    //需在用户可能点击分享按钮前就先调用
    wx.updateAppMessageShareData(shareData);
    wx.updateTimelineShareData(shareData);
  });
  wx.error(function(res) {
    console.log(res);
  });
});
